"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cheerio = require("cheerio");

var service_1 = require("./service");

var Twitter =
/*#__PURE__*/
function (_service_1$Service) {
  _inherits(Twitter, _service_1$Service);

  function Twitter() {
    _classCallCheck(this, Twitter);

    return _possibleConstructorReturn(this, _getPrototypeOf(Twitter).apply(this, arguments));
  }

  _createClass(Twitter, null, [{
    key: "getBaseUrls",
    value: function getBaseUrls() {
      var baseUrls = ['https://twitter.com/', 'http://twitter.com/', 'twitter.com/'];
      return baseUrls;
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(proof) {
      return '';
    }
  }, {
    key: "getProofStatement",
    value: function getProofStatement(searchText) {
      var $ = cheerio.load(searchText);
      var statement = $('meta[property="og:description"]').attr('content');

      if (statement !== undefined) {
        return statement.trim().replace('“', '').replace('”', '');
      } else {
        return '';
      }
    }
  }]);

  return Twitter;
}(service_1.Service);

exports.Twitter = Twitter;